import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "types";

import { Container, Box } from "@mui/material";

import SignIn from "./sections/SignIn";
import SignUp from "./sections/SignUp";
import ResetPassword from "./sections/ResetPassword";

function Auth() {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.user.user);
  const [section, setSection] = useState("login");

  useEffect(() => {
    if (user) navigate("./home", { replace: true });
  }, [user]);

  const setSignup = () => setSection("signup");
  const setSignin = () => setSection("login");
  const setPassReset = () => setSection("reset");

  const renderAuthSection = (): React.ReactNode => {
    switch (section) {
      case "login":
        return <SignIn setSignup={setSignup} setPassReset={setPassReset} />;
      case "signup":
        return <SignUp setSignin={setSignin} />;
      case "reset":
        return <ResetPassword setSignin={setSignin} setSignup={setSignup} />;
      default:
        return <SignIn setSignup={setSignup} setPassReset={setPassReset} />;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        my: 8, // Add margin top and bottom
      }}
    >
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          {renderAuthSection()}
        </Box>
      </Container>
    </Box>
  );
}

export default Auth;
